(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.RuppOrdersDialogHandler = (function(superClass) {
    extend(RuppOrdersDialogHandler, superClass);

    function RuppOrdersDialogHandler() {
      RuppOrdersDialogHandler.__super__.constructor.call(this);
      this.saveData = {};
      this.crop = null;
      this.useMessageWriter = true;
      this.editable = true;
    }

    RuppOrdersDialogHandler.prototype._handleResize = function() {
      this.dialog.find('#orders_container').css({
        'height': '100%'
      });
      this.dialog.find('#orders_steps_container').resizr();
      RuppOrdersDialogHandler.__super__._handleResize.call(this);
      return this.dialog.find('.orders_customer_container').resizr();
    };

    RuppOrdersDialogHandler.prototype.init = function() {
      var k, ref, results, v;
      this.saveUrl = 'backend/grower/rupp-orders/save-order';
      this.currentStep = null;
      this.subHandlers = {
        Customers: {
          "class": 'grower::handlers/rupp_orders/steps/RuppOrdersDialogCustomersHandler',
          attrs: {
            prevStep: null,
            nextStep: 'Lines'
          }
        },
        Lines: {
          "class": 'grower::handlers/rupp_orders/steps/RuppOrdersDialogLinesHandler',
          attrs: {
            prevStep: 'Customers',
            nextStep: 'Discounts'
          }
        },
        Discounts: {
          "class": 'grower::handlers/rupp_orders/steps/RuppOrdersDialogDiscountsHandler',
          attrs: {
            prevStep: 'Lines',
            nextStep: null
          }
        }
      };
      this.firstStep = 'Customers';
      this.layoutUrl = 'backend/grower/rupp-orders/load-layout-dialog';
      this.refreshNavHandler = false;
      this.successAction = this.saveSuccessful;
      this.errorAction = this.saveFailed;
      this.destroyOnSave = true;
      this.createDialog();
      this.dynamicButtonSelectors = {
        'customers': '#btn_add_customer',
        'lines': '#btn_add_line',
        'discounts': '#btn_add_discount',
        'address': null
      };
      this.dynamicObjNames = {};
      ref = this.dynamicButtonSelectors;
      results = [];
      for (k in ref) {
        v = ref[k];
        results.push(this.dynamicObjNames[v] = k);
      }
      return results;
    };

    RuppOrdersDialogHandler.prototype.gotoNext = function() {
      $('#btn_orders_next').prop('disabled', true);
      return this.gotoStep(this.currentStep.nextStep);
    };

    RuppOrdersDialogHandler.prototype.gotoPrev = function() {
      return this.gotoStep(this.currentStep.prevStep);
    };

    RuppOrdersDialogHandler.prototype.gotoStep = function(step) {
      if (step == null) {
        return;
      }
      this.saveFormData();
      step = this.createSubHandler(step);
      if (step) {
        step.loadLayoutPostOptions = JSON.stringify(this.saveData);
        step.init();
        this.currentStep = step;
        this.handleNavButtons();
        return step;
      }
    };

    RuppOrdersDialogHandler.prototype.afterLoadLayout = function(selector, response) {
      var ref;
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      this.saveData = $.extend(true, response.data['order'], this.saveData);
      debugLog('afterLoadLayout');
      debugLog(this.saveData);
      this.gotoStep(this.firstStep);
      this.handleNavButtons();
      this.dialog.find('#btn_orders_next').bind('click', (function(_this) {
        return function() {
          if (_this.currentStep.validator != null) {
            if (_this.currentStep.validator.validating === false) {
              _this.currentStep.validator.startValidating();
            }
            return _this.currentStep.validator.validateAll();
          } else {
            return _this.gotoNext();
          }
        };
      })(this));
      this.dialog.find('#btn_orders_prev').bind('click', (function(_this) {
        return function() {
          return _this.gotoPrev();
        };
      })(this));
      return this.msg = this.dialog.find('.message_writer');
    };

    RuppOrdersDialogHandler.prototype.handleNavButtons = function() {
      var nextBtn;
      if (this.currentStep.prevStep) {
        $('#btn_orders_prev').prop('disabled', false);
      } else {
        $('#btn_orders_prev').prop('disabled', true);
      }
      nextBtn = $('#btn_orders_next');
      nextBtn.show();
      if (this.currentStep.nextStep) {
        return nextBtn.removeClass('save-btn').find('.btn-text').html('Next');
      } else {
        nextBtn.addClass('save-btn').find('.btn-text').html('Save');
        if (!this.editable) {
          return nextBtn.hide();
        }
      }
    };

    RuppOrdersDialogHandler.prototype.getPostData = function() {
      return JSON.stringify(this.saveData);
    };

    RuppOrdersDialogHandler.prototype.saveFormData = function() {
      var arr, btn, dynamic_id, elem, j, len, name, obj, obj_name, ref, results, val;
      ref = $('.order-data');
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        elem = ref[j];
        elem = $(elem);
        name = elem.attr('name');
        if (elem.is('select') || elem.is('input') || elem.is('textarea')) {
          val = elem.val();
        } else {
          val = elem.text();
        }
        dynamic_id = elem.data('dynamic-id');
        if (dynamic_id == null) {
          results.push(this.saveData[name] = val);
        } else {
          btn = elem.data('dynamic-btn');
          obj_name = this.dynamicObjNames[btn];
          if (this.saveData[obj_name] == null) {
            this.saveData[obj_name] = {};
          }
          arr = this.saveData[obj_name];
          if (arr[dynamic_id] == null) {
            arr[dynamic_id] = {};
          }
          obj = arr[dynamic_id];
          results.push(obj[name] = val);
        }
      }
      return results;
    };

    RuppOrdersDialogHandler.prototype.loadFormData = function() {
      var btn, elem, i, k, name, obj, ref, sel, selData, selName, tag, v, val, value;
      ref = this.saveData;
      for (elem in ref) {
        val = ref[elem];
        if ($.isArray(val)) {
          val = this.saveData[elem] = $.extend({}, val);
        }
        if (typeof val !== 'object') {
          sel = "[name='" + elem + "']:first";
          sel = $(sel);
          if (sel.length !== 0) {
            tag = sel.prop('tagName');
            if (tag === 'INPUT' || tag === 'SELECT') {
              sel.val(val).trigger('change');
            } else {
              sel.html(val);
            }
          }
        } else if (val != null) {
          btn = this.dynamicButtonSelectors[elem];
          if (btn === null || $(btn).length !== 0) {
            for (i in val) {
              obj = val[i];
              if (!(!isNaN(parseFloat(i)) && isFinite(i))) {
                selName = "[name='" + i + "']";
                selData = '[data-non-dynamic=1]';
                sel = selName + selData;
                if ($(sel).length !== 0) {
                  $(sel).val(obj);
                }
              } else {
                obj = val[i];
                for (name in obj) {
                  value = obj[name];
                  if (typeof value === 'object') {
                    for (k in value) {
                      v = value[k];
                      this.setLoadFormData(k, i, btn, v);
                    }
                  } else {
                    this.setLoadFormData(name, i, btn, value);
                  }
                }
              }
            }
          }
        }
      }

      /*
      DISABLE GROWER EDITING
       */
      if ((this.saveData.can_edit_order != null) && this.saveData.can_edit_order === false) {
        this.editable = false;
        this.dialog.find('input,select,textarea,.btn').each(function() {
          var ref1;
          if (!((ref1 = $(this).attr('id')) === 'btn_orders_prev' || ref1 === 'btn_orders_next')) {
            return $(this).attr('disabled', 'disabled');
          }
        });
      }
      debugLog('loadFormData: saveData');
      debugLog(this.saveData);
      return this.currentStep.afterLoadData();
    };

    RuppOrdersDialogHandler.prototype.setLoadFormData = function(name, dynamic_id, btn, value) {
      var sel, selData, selName;
      selName = "[name='" + name + "']";
      selData = "[data-dynamic-id='" + dynamic_id + "']";
      sel = selName + selData;
      if ($(sel).length === 0 && $(selData).length === 0 && btn) {
        $(btn).data('id', dynamic_id);
        $(btn).click();
      }
      if ($(sel).length !== 0) {
        if ($(sel).is('input') || $(sel).is('select')) {
          return $(sel).val(value).trigger('change');
        } else {
          return $(sel).html(value);
        }
      }
    };

    RuppOrdersDialogHandler.prototype.deleteFormData = function(name, dynamic_id) {
      if ((this.saveData[name] != null) && (this.saveData[name][dynamic_id] != null)) {
        return delete this.saveData[name][dynamic_id];
      }
    };

    RuppOrdersDialogHandler.prototype.saveSuccessful = function(data) {
      var date, e, filename, name, url;
      this.msg.message_writer('success', 'Order saved');
      try {
        if (data.data['openpdf'] === true) {
          filename = data.data['filename'];
          name = data.data['name'];
          date = data.data['date'];
          url = "backend/grower/rupp-orders/show-pdf?filename=" + filename + "&date=" + date;
          window.open(url);
        }
      } catch (error) {
        e = error;
      }
      return this.reopenSidebar();
    };

    RuppOrdersDialogHandler.prototype.saveFailed = function(data) {
      return this.msg.message_writer('error', 'An error occurred while saving your order. Please try again later.');
    };

    RuppOrdersDialogHandler.prototype.reopenSidebar = function() {
      var base;
      if (!App.sidebar.isOpen) {
        App.sidebar.element.find('.map_sidebar_hide').click();
      }
      return typeof (base = this.parent).orderCompleted === "function" ? base.orderCompleted() : void 0;
    };

    return RuppOrdersDialogHandler;

  })(FullPageHandler);

}).call(this);
